import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import './studyStyles.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import globalUseStyles from '../../styleHooks';
import studyClasses from './studyStyles.js';


function StudyServices() {
  const globalClasses = globalUseStyles()
  const studyStyles = studyClasses()
  return (
<ThemeProvider theme={theme}>
   <Container className={"studyServicesStyle"} maxWidth={false} component="section">
      <Container className={"studyServicesStyleInner"} maxWidth={false} component="section">
         <Grid className={globalClasses.containerVertPadding} container>
            <Grid className={globalClasses.containerSmall} container >
               <Grid item xs={12} md={12}  >
                  <Typography variant="subtitle1">What we did</Typography>
                  <Typography variant="h2">Services Performed</Typography>
               </Grid>
               <Grid item xs={12} md={12} className={studyStyles.whiteBox} container >
                  <Grid item xs={12} md={6} container >
                  <List className={globalClasses.noPadding}>
                        <ListItem disableGutters className={studyStyles.listPadding}>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- Agile-based Technical Project Management</Typography>
                           </ListItemText>
                        </ListItem>
                        <ListItem disableGutters className={studyStyles.listPadding}>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- Discovery and Business Analysis</Typography>
                           </ListItemText>
                        </ListItem>
                        <ListItem disableGutters className={studyStyles.listPadding}>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- User Research</Typography>
                           </ListItemText>
                        </ListItem>
                        <ListItem disableGutters className={studyStyles.listPadding}>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- UX Design</Typography>
                           </ListItemText>
                        </ListItem>
                     </List>
                  </Grid>
                  <Grid item xs={12} md={6} container >
                  <List className={globalClasses.noPadding}>
                  <ListItem disableGutters>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- Business Intelligence and Dashboard Implementation</Typography>
                           </ListItemText>
                        </ListItem>
                        <ListItem disableGutters>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- Cloud Native Development</Typography>
                           </ListItemText>
                        </ListItem>
                        <ListItem disableGutters>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- Data Collection and Survey Implementation</Typography>
                           </ListItemText>
                        </ListItem>
                        <ListItem disableGutters>
                           <ListItemText classes={{primary:globalClasses.listItemText}}>
                              <Typography variant="h5">- Microservices based Dev Ops</Typography>
                           </ListItemText>
                        </ListItem>
                     </List>
                  </Grid>
               </Grid>
            </Grid>
         </Grid>
      </Container>
   </Container>
</ThemeProvider>
  );
};

export default StudyServices;